import {
  Companion_getInstance1up45os1rj3ws as Companion_getInstance,
  IncidentMessageComment1adwwkgdgyo0h as IncidentMessageComment,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_incident(_this__u8e3s4) {
  return _this__u8e3s4.prop(IncidentMessageComment_incident_getInstance());
}
function get_created(_this__u8e3s4) {
  return _this__u8e3s4.prop(IncidentMessageComment_created_getInstance());
}
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(IncidentMessageComment_project_getInstance());
}
function prepareIncidentMessageCommentFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [IncidentMessageComment__id_getInstance(), IncidentMessageComment_incidentMessage_getInstance(), IncidentMessageComment_project_getInstance(), IncidentMessageComment_incident_getInstance(), IncidentMessageComment_sender_getInstance(), IncidentMessageComment_senderName_getInstance(), IncidentMessageComment_clientMessage_getInstance(), IncidentMessageComment_message_getInstance(), IncidentMessageComment_readBy_getInstance(), IncidentMessageComment_created_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function IncidentMessageComment_incident$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(3);
}
function IncidentMessageComment_incident$_get_name_$ref_vdodzg() {
  return (p0) => p0.i20();
}
function IncidentMessageComment_incident$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentMessageComment_incident$_get_serializer_$ref_golrqd() {
  return (p0) => p0.h2j();
}
function IncidentMessageComment_incident$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(3);
}
function IncidentMessageComment_incident$_get_annotations_$ref_3v9fcv() {
  return (p0) => p0.bz();
}
var IncidentMessageComment_incidentClass;
function IncidentMessageComment_incident() {
  if (IncidentMessageComment_incidentClass === VOID) {
    class $ {
      constructor() {
        IncidentMessageComment_incident_instance = this;
        var tmp = this;
        tmp.m65_1 = lazy(IncidentMessageComment_incident$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n65_1 = lazy(IncidentMessageComment_incident$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o65_1 = lazy(IncidentMessageComment_incident$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.m65_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentMessageComment_incident$_get_name_$ref_vdodzg(), null);
        return tmp0.f2();
      }
      p65(receiver) {
        return receiver.t65_1;
      }
      k2j(receiver) {
        return this.p65(receiver instanceof IncidentMessageComment() ? receiver : THROW_CCE());
      }
      a66(receiver, value) {
        return receiver.b66(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof IncidentMessageComment() ? receiver : THROW_CCE();
        return this.a66(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.n65_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentMessageComment_incident$_get_serializer_$ref_golrqd(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o65_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentMessageComment_incident$_get_annotations_$ref_3v9fcv(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentMessageComment_incident', VOID, VOID, [SerializableProperty()]);
    IncidentMessageComment_incidentClass = $;
  }
  return IncidentMessageComment_incidentClass;
}
var IncidentMessageComment_incident_instance;
function IncidentMessageComment_incident_getInstance() {
  if (IncidentMessageComment_incident_instance === VOID)
    new (IncidentMessageComment_incident())();
  return IncidentMessageComment_incident_instance;
}
function IncidentMessageComment_created$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(9);
}
function IncidentMessageComment_created$_get_name_$ref_2c2v28() {
  return (p0) => p0.i20();
}
function IncidentMessageComment_created$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentMessageComment_created$_get_serializer_$ref_ehq8p() {
  return (p0) => p0.h2j();
}
function IncidentMessageComment_created$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(9);
}
function IncidentMessageComment_created$_get_annotations_$ref_3mfh11() {
  return (p0) => p0.bz();
}
var IncidentMessageComment_createdClass;
function IncidentMessageComment_created() {
  if (IncidentMessageComment_createdClass === VOID) {
    class $ {
      constructor() {
        IncidentMessageComment_created_instance = this;
        var tmp = this;
        tmp.c66_1 = lazy(IncidentMessageComment_created$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d66_1 = lazy(IncidentMessageComment_created$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e66_1 = lazy(IncidentMessageComment_created$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.f66_1 = get_default(Companion_instance).b1m();
        this.g66_1 = 'now()';
      }
      i20() {
        var tmp0 = this.c66_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentMessageComment_created$_get_name_$ref_2c2v28(), null);
        return tmp0.f2();
      }
      p65(receiver) {
        return receiver.z65_1;
      }
      k2j(receiver) {
        return this.p65(receiver instanceof IncidentMessageComment() ? receiver : THROW_CCE());
      }
      h66(receiver, value) {
        return receiver.b66(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof IncidentMessageComment() ? receiver : THROW_CCE();
        return this.h66(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.d66_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentMessageComment_created$_get_serializer_$ref_ehq8p(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e66_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentMessageComment_created$_get_annotations_$ref_3mfh11(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentMessageComment_created', VOID, VOID, [SerializableProperty()]);
    IncidentMessageComment_createdClass = $;
  }
  return IncidentMessageComment_createdClass;
}
var IncidentMessageComment_created_instance;
function IncidentMessageComment_created_getInstance() {
  if (IncidentMessageComment_created_instance === VOID)
    new (IncidentMessageComment_created())();
  return IncidentMessageComment_created_instance;
}
function IncidentMessageComment_project$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(2);
}
function IncidentMessageComment_project$_get_name_$ref_1x6wa7() {
  return (p0) => p0.i20();
}
function IncidentMessageComment_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentMessageComment_project$_get_serializer_$ref_159x8o() {
  return (p0) => p0.h2j();
}
function IncidentMessageComment_project$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(2);
}
function IncidentMessageComment_project$_get_annotations_$ref_jfujy4() {
  return (p0) => p0.bz();
}
var IncidentMessageComment_projectClass;
function IncidentMessageComment_project() {
  if (IncidentMessageComment_projectClass === VOID) {
    class $ {
      constructor() {
        IncidentMessageComment_project_instance = this;
        var tmp = this;
        tmp.i66_1 = lazy(IncidentMessageComment_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j66_1 = lazy(IncidentMessageComment_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k66_1 = lazy(IncidentMessageComment_project$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.i66_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentMessageComment_project$_get_name_$ref_1x6wa7(), null);
        return tmp0.f2();
      }
      p65(receiver) {
        return receiver.s65_1;
      }
      k2j(receiver) {
        return this.p65(receiver instanceof IncidentMessageComment() ? receiver : THROW_CCE());
      }
      a66(receiver, value) {
        return receiver.b66(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof IncidentMessageComment() ? receiver : THROW_CCE();
        return this.a66(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.j66_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentMessageComment_project$_get_serializer_$ref_159x8o(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k66_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentMessageComment_project$_get_annotations_$ref_jfujy4(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentMessageComment_project', VOID, VOID, [SerializableProperty()]);
    IncidentMessageComment_projectClass = $;
  }
  return IncidentMessageComment_projectClass;
}
var IncidentMessageComment_project_instance;
function IncidentMessageComment_project_getInstance() {
  if (IncidentMessageComment_project_instance === VOID)
    new (IncidentMessageComment_project())();
  return IncidentMessageComment_project_instance;
}
function IncidentMessageComment__id$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function IncidentMessageComment__id$_get_name_$ref_6jb8sy() {
  return (p0) => p0.i20();
}
function IncidentMessageComment__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentMessageComment__id$_get_serializer_$ref_89xq7t() {
  return (p0) => p0.h2j();
}
function IncidentMessageComment__id$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function IncidentMessageComment__id$_get_annotations_$ref_bgpknx() {
  return (p0) => p0.bz();
}
var IncidentMessageComment__idClass;
function IncidentMessageComment__id() {
  if (IncidentMessageComment__idClass === VOID) {
    class $ {
      constructor() {
        IncidentMessageComment__id_instance = this;
        var tmp = this;
        tmp.l66_1 = lazy(IncidentMessageComment__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m66_1 = lazy(IncidentMessageComment__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n66_1 = lazy(IncidentMessageComment__id$annotations$delegate$lambda);
        this.o66_1 = Companion_getInstance_0().k2p();
        this.p66_1 = 'UUID.random()';
      }
      i20() {
        var tmp0 = this.l66_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentMessageComment__id$_get_name_$ref_6jb8sy(), null);
        return tmp0.f2();
      }
      p65(receiver) {
        return receiver.q65_1;
      }
      k2j(receiver) {
        return this.p65(receiver instanceof IncidentMessageComment() ? receiver : THROW_CCE());
      }
      a66(receiver, value) {
        return receiver.b66(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof IncidentMessageComment() ? receiver : THROW_CCE();
        return this.a66(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.m66_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentMessageComment__id$_get_serializer_$ref_89xq7t(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n66_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentMessageComment__id$_get_annotations_$ref_bgpknx(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentMessageComment__id', VOID, VOID, [SerializableProperty()]);
    IncidentMessageComment__idClass = $;
  }
  return IncidentMessageComment__idClass;
}
var IncidentMessageComment__id_instance;
function IncidentMessageComment__id_getInstance() {
  if (IncidentMessageComment__id_instance === VOID)
    new (IncidentMessageComment__id())();
  return IncidentMessageComment__id_instance;
}
function IncidentMessageComment_incidentMessage$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function IncidentMessageComment_incidentMessage$_get_name_$ref_awggxf() {
  return (p0) => p0.i20();
}
function IncidentMessageComment_incidentMessage$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentMessageComment_incidentMessage$_get_serializer_$ref_xup5jg() {
  return (p0) => p0.h2j();
}
function IncidentMessageComment_incidentMessage$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function IncidentMessageComment_incidentMessage$_get_annotations_$ref_w4q4eg() {
  return (p0) => p0.bz();
}
var IncidentMessageComment_incidentMessageClass;
function IncidentMessageComment_incidentMessage() {
  if (IncidentMessageComment_incidentMessageClass === VOID) {
    class $ {
      constructor() {
        IncidentMessageComment_incidentMessage_instance = this;
        var tmp = this;
        tmp.q66_1 = lazy(IncidentMessageComment_incidentMessage$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r66_1 = lazy(IncidentMessageComment_incidentMessage$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s66_1 = lazy(IncidentMessageComment_incidentMessage$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.q66_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentMessageComment_incidentMessage$_get_name_$ref_awggxf(), null);
        return tmp0.f2();
      }
      p65(receiver) {
        return receiver.r65_1;
      }
      k2j(receiver) {
        return this.p65(receiver instanceof IncidentMessageComment() ? receiver : THROW_CCE());
      }
      a66(receiver, value) {
        return receiver.b66(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof IncidentMessageComment() ? receiver : THROW_CCE();
        return this.a66(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.r66_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentMessageComment_incidentMessage$_get_serializer_$ref_xup5jg(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s66_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentMessageComment_incidentMessage$_get_annotations_$ref_w4q4eg(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentMessageComment_incidentMessage', VOID, VOID, [SerializableProperty()]);
    IncidentMessageComment_incidentMessageClass = $;
  }
  return IncidentMessageComment_incidentMessageClass;
}
var IncidentMessageComment_incidentMessage_instance;
function IncidentMessageComment_incidentMessage_getInstance() {
  if (IncidentMessageComment_incidentMessage_instance === VOID)
    new (IncidentMessageComment_incidentMessage())();
  return IncidentMessageComment_incidentMessage_instance;
}
function IncidentMessageComment_sender$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(4);
}
function IncidentMessageComment_sender$_get_name_$ref_q66iwn() {
  return (p0) => p0.i20();
}
function IncidentMessageComment_sender$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentMessageComment_sender$_get_serializer_$ref_xd76ci() {
  return (p0) => p0.h2j();
}
function IncidentMessageComment_sender$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(4);
}
function IncidentMessageComment_sender$_get_annotations_$ref_ntwmle() {
  return (p0) => p0.bz();
}
var IncidentMessageComment_senderClass;
function IncidentMessageComment_sender() {
  if (IncidentMessageComment_senderClass === VOID) {
    class $ {
      constructor() {
        IncidentMessageComment_sender_instance = this;
        var tmp = this;
        tmp.t66_1 = lazy(IncidentMessageComment_sender$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u66_1 = lazy(IncidentMessageComment_sender$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v66_1 = lazy(IncidentMessageComment_sender$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.t66_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentMessageComment_sender$_get_name_$ref_q66iwn(), null);
        return tmp0.f2();
      }
      p65(receiver) {
        return receiver.u65_1;
      }
      k2j(receiver) {
        return this.p65(receiver instanceof IncidentMessageComment() ? receiver : THROW_CCE());
      }
      a66(receiver, value) {
        return receiver.b66(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof IncidentMessageComment() ? receiver : THROW_CCE();
        return this.a66(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.u66_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentMessageComment_sender$_get_serializer_$ref_xd76ci(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v66_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentMessageComment_sender$_get_annotations_$ref_ntwmle(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentMessageComment_sender', VOID, VOID, [SerializableProperty()]);
    IncidentMessageComment_senderClass = $;
  }
  return IncidentMessageComment_senderClass;
}
var IncidentMessageComment_sender_instance;
function IncidentMessageComment_sender_getInstance() {
  if (IncidentMessageComment_sender_instance === VOID)
    new (IncidentMessageComment_sender())();
  return IncidentMessageComment_sender_instance;
}
function IncidentMessageComment_senderName$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(5);
}
function IncidentMessageComment_senderName$_get_name_$ref_7gsf9e() {
  return (p0) => p0.i20();
}
function IncidentMessageComment_senderName$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentMessageComment_senderName$_get_serializer_$ref_drsydz() {
  return (p0) => p0.h2j();
}
function IncidentMessageComment_senderName$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(5);
}
function IncidentMessageComment_senderName$_get_annotations_$ref_fcfsc3() {
  return (p0) => p0.bz();
}
var IncidentMessageComment_senderNameClass;
function IncidentMessageComment_senderName() {
  if (IncidentMessageComment_senderNameClass === VOID) {
    class $ {
      constructor() {
        IncidentMessageComment_senderName_instance = this;
        var tmp = this;
        tmp.w66_1 = lazy(IncidentMessageComment_senderName$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x66_1 = lazy(IncidentMessageComment_senderName$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y66_1 = lazy(IncidentMessageComment_senderName$annotations$delegate$lambda);
        this.z66_1 = '';
        this.a67_1 = '""';
      }
      i20() {
        var tmp0 = this.w66_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentMessageComment_senderName$_get_name_$ref_7gsf9e(), null);
        return tmp0.f2();
      }
      p65(receiver) {
        return receiver.v65_1;
      }
      k2j(receiver) {
        return this.p65(receiver instanceof IncidentMessageComment() ? receiver : THROW_CCE());
      }
      b67(receiver, value) {
        return receiver.b66(VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof IncidentMessageComment() ? receiver : THROW_CCE();
        return this.b67(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.x66_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentMessageComment_senderName$_get_serializer_$ref_drsydz(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y66_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentMessageComment_senderName$_get_annotations_$ref_fcfsc3(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentMessageComment_senderName', VOID, VOID, [SerializableProperty()]);
    IncidentMessageComment_senderNameClass = $;
  }
  return IncidentMessageComment_senderNameClass;
}
var IncidentMessageComment_senderName_instance;
function IncidentMessageComment_senderName_getInstance() {
  if (IncidentMessageComment_senderName_instance === VOID)
    new (IncidentMessageComment_senderName())();
  return IncidentMessageComment_senderName_instance;
}
function IncidentMessageComment_clientMessage$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(6);
}
function IncidentMessageComment_clientMessage$_get_name_$ref_97vr9w() {
  return (p0) => p0.i20();
}
function IncidentMessageComment_clientMessage$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentMessageComment_clientMessage$_get_serializer_$ref_vuexvf() {
  return (p0) => p0.h2j();
}
function IncidentMessageComment_clientMessage$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(6);
}
function IncidentMessageComment_clientMessage$_get_annotations_$ref_8uzgwx() {
  return (p0) => p0.bz();
}
var IncidentMessageComment_clientMessageClass;
function IncidentMessageComment_clientMessage() {
  if (IncidentMessageComment_clientMessageClass === VOID) {
    class $ {
      constructor() {
        IncidentMessageComment_clientMessage_instance = this;
        var tmp = this;
        tmp.c67_1 = lazy(IncidentMessageComment_clientMessage$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d67_1 = lazy(IncidentMessageComment_clientMessage$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e67_1 = lazy(IncidentMessageComment_clientMessage$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.c67_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentMessageComment_clientMessage$_get_name_$ref_97vr9w(), null);
        return tmp0.f2();
      }
      p65(receiver) {
        return receiver.w65_1;
      }
      k2j(receiver) {
        return this.p65(receiver instanceof IncidentMessageComment() ? receiver : THROW_CCE());
      }
      f67(receiver, value) {
        return receiver.b66(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof IncidentMessageComment() ? receiver : THROW_CCE();
        return this.f67(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.d67_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentMessageComment_clientMessage$_get_serializer_$ref_vuexvf(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e67_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentMessageComment_clientMessage$_get_annotations_$ref_8uzgwx(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentMessageComment_clientMessage', VOID, VOID, [SerializableProperty()]);
    IncidentMessageComment_clientMessageClass = $;
  }
  return IncidentMessageComment_clientMessageClass;
}
var IncidentMessageComment_clientMessage_instance;
function IncidentMessageComment_clientMessage_getInstance() {
  if (IncidentMessageComment_clientMessage_instance === VOID)
    new (IncidentMessageComment_clientMessage())();
  return IncidentMessageComment_clientMessage_instance;
}
function IncidentMessageComment_message$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(7);
}
function IncidentMessageComment_message$_get_name_$ref_q3js8v() {
  return (p0) => p0.i20();
}
function IncidentMessageComment_message$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentMessageComment_message$_get_serializer_$ref_l8vty2() {
  return (p0) => p0.h2j();
}
function IncidentMessageComment_message$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(7);
}
function IncidentMessageComment_message$_get_annotations_$ref_39p816() {
  return (p0) => p0.bz();
}
var IncidentMessageComment_messageClass;
function IncidentMessageComment_message() {
  if (IncidentMessageComment_messageClass === VOID) {
    class $ {
      constructor() {
        IncidentMessageComment_message_instance = this;
        var tmp = this;
        tmp.g67_1 = lazy(IncidentMessageComment_message$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h67_1 = lazy(IncidentMessageComment_message$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i67_1 = lazy(IncidentMessageComment_message$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.g67_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentMessageComment_message$_get_name_$ref_q3js8v(), null);
        return tmp0.f2();
      }
      p65(receiver) {
        return receiver.x65_1;
      }
      k2j(receiver) {
        return this.p65(receiver instanceof IncidentMessageComment() ? receiver : THROW_CCE());
      }
      b67(receiver, value) {
        return receiver.b66(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof IncidentMessageComment() ? receiver : THROW_CCE();
        return this.b67(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.h67_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentMessageComment_message$_get_serializer_$ref_l8vty2(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i67_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentMessageComment_message$_get_annotations_$ref_39p816(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentMessageComment_message', VOID, VOID, [SerializableProperty()]);
    IncidentMessageComment_messageClass = $;
  }
  return IncidentMessageComment_messageClass;
}
var IncidentMessageComment_message_instance;
function IncidentMessageComment_message_getInstance() {
  if (IncidentMessageComment_message_instance === VOID)
    new (IncidentMessageComment_message())();
  return IncidentMessageComment_message_instance;
}
function IncidentMessageComment_readBy$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(8);
}
function IncidentMessageComment_readBy$_get_name_$ref_jr3lo1() {
  return (p0) => p0.i20();
}
function IncidentMessageComment_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentMessageComment_readBy$_get_serializer_$ref_4tf62y() {
  return (p0) => p0.h2j();
}
function IncidentMessageComment_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(8);
}
function IncidentMessageComment_readBy$_get_annotations_$ref_8tuxxi() {
  return (p0) => p0.bz();
}
var IncidentMessageComment_readByClass;
function IncidentMessageComment_readBy() {
  if (IncidentMessageComment_readByClass === VOID) {
    class $ {
      constructor() {
        IncidentMessageComment_readBy_instance = this;
        var tmp = this;
        tmp.j67_1 = lazy(IncidentMessageComment_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.k67_1 = lazy(IncidentMessageComment_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.l67_1 = lazy(IncidentMessageComment_readBy$annotations$delegate$lambda);
        this.m67_1 = emptySet();
        this.n67_1 = 'emptySet()';
      }
      i20() {
        var tmp0 = this.j67_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentMessageComment_readBy$_get_name_$ref_jr3lo1(), null);
        return tmp0.f2();
      }
      p65(receiver) {
        return receiver.y65_1;
      }
      k2j(receiver) {
        return this.p65(receiver instanceof IncidentMessageComment() ? receiver : THROW_CCE());
      }
      o67(receiver, value) {
        return receiver.b66(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof IncidentMessageComment() ? receiver : THROW_CCE();
        return this.o67(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.k67_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentMessageComment_readBy$_get_serializer_$ref_4tf62y(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.l67_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentMessageComment_readBy$_get_annotations_$ref_8tuxxi(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentMessageComment_readBy', VOID, VOID, [SerializableProperty()]);
    IncidentMessageComment_readByClass = $;
  }
  return IncidentMessageComment_readByClass;
}
var IncidentMessageComment_readBy_instance;
function IncidentMessageComment_readBy_getInstance() {
  if (IncidentMessageComment_readBy_instance === VOID)
    new (IncidentMessageComment_readBy())();
  return IncidentMessageComment_readBy_instance;
}
//region block: exports
export {
  get_created as get_created200bf4xepfbhm,
  get_incident as get_incidenti9ia7anmnpwp,
  prepareIncidentMessageCommentFields as prepareIncidentMessageCommentFields1oieun7s2tnlc,
  get_project as get_project1wlofjeblezw8,
};
//endregion

//# sourceMappingURL=IncidentMessageCommentFields.mjs.map
